import React, { useCallback } from 'react';

function roundRect(ctx, x, y, w, h, r) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.lineTo(x + w - r, y);
  ctx.quadraticCurveTo(x + w, y, x + w, y + r);
  ctx.lineTo(x + w, y + h - r);
  ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
  ctx.lineTo(x + r, y + h);
  ctx.quadraticCurveTo(x, y + h, x, y + h - r);
  ctx.lineTo(x, y + r);
  ctx.quadraticCurveTo(x, y, x + r, y);
  ctx.closePath();
}

function wrapText(ctx, text, x, y, maxWidth, lineHeight, returnCount = false) {
  const words = (text || '').split(' ');
  let line = '';
  let lineCount = 0;
  const maxLines = 6;
  for (let i = 0; i < words.length; i++) {
    const testLine = line + words[i] + ' ';
    const metrics = ctx.measureText(testLine);
    if (metrics.width > maxWidth && i > 0) {
      ctx.fillText(line.trim(), x, y);
      line = words[i] + ' ';
      y += lineHeight;
      lineCount++;
      if (lineCount >= maxLines) { ctx.fillText(line.trim() + '...', x, y); lineCount++; break; }
    } else { line = testLine; }
  }
  if (lineCount < maxLines && line.trim()) { ctx.fillText(line.trim(), x, y); lineCount++; }
  return returnCount ? lineCount : y;
}

export function generateShareableImage(review) {
  return new Promise((resolve) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const W = 1080; const H = 1350;
    canvas.width = W; canvas.height = H;
    ctx.fillStyle = '#0B2352'; ctx.fillRect(0, 0, W, H);
    ctx.fillStyle = '#D4A24C'; ctx.fillRect(0, 0, W, 8);
    ctx.fillStyle = '#D4A24C'; roundRect(ctx, 60, 60, 220, 50, 25); ctx.fill();
    ctx.fillStyle = '#0B2352'; ctx.font = 'bold 22px -apple-system, BlinkMacSystemFont, sans-serif'; ctx.fillText('🔥 Real Talk', 85, 93);
    ctx.fillStyle = '#FFFFFF'; ctx.font = 'bold 48px -apple-system, BlinkMacSystemFont, sans-serif'; wrapText(ctx, review.college_name, 60, 190, W - 120, 58);
    ctx.fillStyle = '#D4A24C'; ctx.font = '28px -apple-system, BlinkMacSystemFont, sans-serif'; ctx.fillText(`${review.course} · ${review.year}`, 60, 280);
    ctx.strokeStyle = 'rgba(212, 162, 76, 0.3)'; ctx.lineWidth = 2; ctx.beginPath(); ctx.moveTo(60, 320); ctx.lineTo(W - 60, 320); ctx.stroke();
    const categories = [
      { key: 'academics', label: 'Academics' },
      { key: 'placements', label: 'Placements' },
      { key: 'campus_life', label: 'Campus Life' },
      { key: 'faculty', label: 'Faculty' },
      { key: 'value_for_money', label: 'Value for Money' },
    ];
    let y = 380;
    categories.forEach(({ key, label }) => {
      const val = (review.ratings || {})[key] || 0;
      ctx.fillStyle = '#FFFFFF'; ctx.font = '24px -apple-system, BlinkMacSystemFont, sans-serif'; ctx.fillText(label, 60, y);
      ctx.font = '28px -apple-system, BlinkMacSystemFont, sans-serif';
      let starStr = '';
      for (let i = 1; i <= 5; i++) starStr += i <= val ? '★' : '☆';
      ctx.fillStyle = '#D4A24C'; ctx.fillText(starStr, 350, y);
      y += 50;
    });
    y += 30;
    ctx.strokeStyle = 'rgba(212, 162, 76, 0.3)'; ctx.beginPath(); ctx.moveTo(60, y - 20); ctx.lineTo(W - 60, y - 20); ctx.stroke();
    const verdictText = review.ai_verdict || review.written_review || '';
    ctx.fillStyle = '#FFFFFF'; ctx.font = 'italic 30px -apple-system, BlinkMacSystemFont, sans-serif'; ctx.fillText('"', 50, y + 10);
    ctx.font = '28px -apple-system, BlinkMacSystemFont, sans-serif';
    const lines = wrapText(ctx, verdictText, 80, y + 10, W - 160, 38, true);
    const verdictEndY = y + 10 + lines * 38;
    ctx.font = 'italic 30px -apple-system, BlinkMacSystemFont, sans-serif'; ctx.fillText('"', W - 80, verdictEndY);
    const overall = review.overall_rating || (Object.values(review.ratings || {}).reduce((a, b) => a + b, 0) / 5).toFixed(1);
    const circleY = H - 220;
    ctx.beginPath(); ctx.arc(W / 2, circleY, 60, 0, Math.PI * 2); ctx.fillStyle = '#D4A24C'; ctx.fill();
    ctx.fillStyle = '#0B2352'; ctx.font = 'bold 40px -apple-system, BlinkMacSystemFont, sans-serif'; ctx.textAlign = 'center'; ctx.fillText(String(overall), W / 2, circleY + 14);
    ctx.fillStyle = 'rgba(255,255,255,0.6)'; ctx.font = '18px -apple-system, BlinkMacSystemFont, sans-serif'; ctx.fillText('OVERALL', W / 2, circleY + 45); ctx.textAlign = 'left';
    ctx.fillStyle = 'rgba(255,255,255,0.5)'; ctx.font = '20px -apple-system, BlinkMacSystemFont, sans-serif'; ctx.textAlign = 'center';
    const reviewerLabel = review.is_anonymous ? '— Anonymous Student' : `— ${review.reviewer_name || 'A Student'}`;
    ctx.fillText(reviewerLabel, W / 2, H - 110);
    ctx.fillStyle = '#D4A24C'; ctx.fillRect(0, H - 70, W, 70);
    ctx.fillStyle = '#0B2352'; ctx.font = 'bold 24px -apple-system, BlinkMacSystemFont, sans-serif'; ctx.fillText('collegeunlock.com/real-talk', W / 2, H - 32); ctx.textAlign = 'left';
    ctx.strokeStyle = '#D4A24C'; ctx.lineWidth = 4; ctx.strokeRect(2, 2, W - 4, H - 4);
    canvas.toBlob((blob) => resolve(blob), 'image/png', 1.0);
  });
}

export default function ShareButton({ review }) {
  const handleShare = useCallback(async () => {
    try {
      const blob = await generateShareableImage(review);
      if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('event', 'verdict_shared', { college_name: review.college_name, method: 'generated' });
      }
      if (navigator.share && navigator.canShare) {
        const file = new File([blob], `${review.college_name}-verdict.png`, { type: 'image/png' });
        const shareData = { title: `${review.college_name} - Real Talk Verdict`, text: 'Check out this honest college verdict on CollegeUnlock 🔥', url: 'https://www.collegeunlock.com/real-talk', files: [file] };
        if (navigator.canShare(shareData)) { await navigator.share(shareData); return; }
      }
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url; a.download = `${review.college_name.replace(/\s+/g, '-')}-verdict.png`;
      document.body.appendChild(a); a.click(); document.body.removeChild(a); URL.revokeObjectURL(url);
    } catch { /* share cancelled or failed — silent */ }
  }, [review]);

  const handleWhatsAppShare = useCallback(() => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'verdict_shared', { college_name: review.college_name, method: 'whatsapp' });
    }
    const text = encodeURIComponent(`🔥 ${review.college_name} verdict by a real student!\n\n"${(review.ai_verdict || review.written_review || '').substring(0, 200)}"\n\nRead more honest verdicts: https://www.collegeunlock.com/real-talk`);
    window.open(`https://wa.me/?text=${text}`, '_blank');
  }, [review]);

  return (
    <div className="rt-share-buttons">
      <button onClick={handleShare} className="rt-share-btn rt-share-download" title="Download verdict card" data-testid="rt-share-btn">📥 Share</button>
      <button onClick={handleWhatsAppShare} className="rt-share-btn rt-share-whatsapp" title="Share on WhatsApp" data-testid="rt-share-whatsapp">💬 WhatsApp</button>
    </div>
  );
}
